// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"952e83aa","127":"952e83aa","810":"4a8a28e0","851":"406297c0","860":"eb6bca5c","895":"952e83aa","928":"b663123d"}[chunkId] + ".chunk.css";
};